import { render, staticRenderFns } from "./CalculoNomina.vue?vue&type=template&id=5e32ae68&scoped=true"
import script from "./CalculoNomina.vue?vue&type=script&lang=js"
export * from "./CalculoNomina.vue?vue&type=script&lang=js"
import style0 from "./CalculoNomina.vue?vue&type=style&index=0&id=5e32ae68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e32ae68",
  null
  
)

export default component.exports